import { render } from "./EditJobDrawer.vue?vue&type=template&id=35b0dd43&ts=true"
import script from "./EditJobDrawer.vue?vue&type=script&lang=ts"
export * from "./EditJobDrawer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__